export const MODEL_FIELDS = Object.freeze({
  pricingTiers: "pricingTiers",
});

export const FilterModel = {
  [MODEL_FIELDS.pricingTiers]: {
    fieldName: MODEL_FIELDS.pricingTiers,
    fieldType: "multiSelectFilterInput",
    label: "package",
    elementId: "package-selector",
    options: [
      { value: "1m", label: "1m" },
      { value: "2m", label: "2m" },
      { value: "3m", label: "3m" },
      { value: "1m_basic", label: "1m Basic" },
      { value: "2m_basic", label: "2m Basic" },
      { value: "3m_basic", label: "3m Basic" },
      { value: "3m_pro", label: "3m Pro" },
      { value: "6m_vip", label: "Premium" },
    ],
  },
};
